import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './Clients.css';

export default function Clients() {
    const [direction, setDirection] = useState('normal');

    // Using images from the public directory
    const clients = [
        { name: "Ali & Sons", image: "/clients/ali_and_sons.jpeg" },
        { name: "Emirates Motor Company", image: "/clients/WhatsApp Image 2025-12-08 at 00.26.46.jpeg" },
        { name: "Gulf & Safa Dairies", image: "/clients/WhatsApp Image 2025-12-08 at 00.26.47.jpeg" },
        { name: "Jeep Western Motors", image: "/clients/WhatsApp Image 2025-12-08 at 00.26.48.jpeg" },
        { name: "Client 6", image: "/clients/WhatsApp Image 2025-12-08 at 00.41.09.jpeg" },
        { name: "Client 7", image: "/clients/WhatsApp Image 2025-12-08 at 00.44.00.jpeg" },
        { name: "Client 8", image: "/clients/WhatsApp Image 2025-12-08 at 00.45.52.jpeg" },
        { name: "Client 9", image: "/clients/WhatsApp Image 2025-12-08 at 00.50.58.jpeg" },
        { name: "Client 10", image: "/clients/WhatsApp Image 2025-12-08 at 00.52.26.jpeg" },
        { name: "Client 11", image: "/clients/WhatsApp Image 2025-12-08 at 00.53.34.jpeg" },
        { name: "Client 12", image: "/clients/WhatsApp Image 2025-12-08 at 00.57.06.jpeg" },
        { name: "Client 13", image: "/clients/WhatsApp Image 2025-12-08 at 00.58.21.jpeg" },
        { name: "Client 14", image: "/clients/WhatsApp Image 2026-01-11 at 03.18.49.jpeg" },
        { name: "Client 15", image: "/clients/WhatsApp Image 2026-01-11 at 03.22.29.jpeg" },
        { name: "Client 16", image: "/clients/WhatsApp Image 2026-01-11 at 03.26.01.jpeg" },
        { name: "Client 17", image: "/clients/SehaClinic.jpg" },
        { name: "Client 18", image: "/clients/pharmalink.jpeg" },
    ];

    return (
        <section className="clients-section">
            <div className="clients-container">
                <h2 className="clients-title">Featured Clients</h2>

                <button
                    className="carousel-btn left"
                    onClick={() => setDirection('normal')}
                >
                    <ChevronLeft size={60} />
                </button>

                <div className="clients-carousel-wrapper">
                    <div className="clients-track" style={{ animationDirection: direction }}>
                        {/* First set of clients */}
                        <div className="client-slide">
                            {clients.map((client, i) => (
                                <div key={`a-${i}`} className="client-item" title={client.name}>
                                    <img
                                        src={client.image}
                                        alt={`${client.name} - Client of Rainbow Craft Signs & Graphics Dubai, UAE`}
                                        className="client-logo"
                                    />
                                </div>
                            ))}
                        </div>
                        {/* Duplicate set for seamless loop */}
                        <div className="client-slide">
                            {clients.map((client, i) => (
                                <div key={`b-${i}`} className="client-item" title={client.name}>
                                    <img
                                        src={client.image}
                                        alt={`${client.name} - Client of Rainbow Craft Signs & Graphics Dubai, UAE`}
                                        className="client-logo"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <button
                    className="carousel-btn right"
                    onClick={() => setDirection('reverse')}
                >
                    <ChevronRight size={60} />
                </button>
            </div>
        </section>
    );
}
